import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 64px;

  > * {
    margin-bottom: 32px;
  }
`;
